import React from "react";
import { Col, Row } from "antd";
import { Video, Map } from "react-feather";

import DisplayCard from "../../DisplayCard/DisplayCard";

const UserExperience = () => {
  return (
    <div className="site-card-wrapper">
      <Row gutter={16}>
        <Col span={12} style={{ display: "flex" }}>
          <DisplayCard
            icon={<Video strokeWidth={1} size={16} />}
            heading="RECORDINGS"
            title="See how users experience your site"
            description="Learn what’s getting their attention, and drive your next design
              decisions with data."
            buttonText="View Your First Recording"
            buttonDisabled
          />
        </Col>
        <Col span={12} style={{ display: "flex" }}>
          <DisplayCard
            icon={<Map strokeWidth={1} size={16} />}
            heading="HEATMAPS"
            title="Find out what your users really care about"
            description=" Understand their journeys and where they’re struggling to reach
            their goal."
            buttonText="Start Heatmapping"
            buttonDisabled
          />
        </Col>
      </Row>
    </div>
  );
};

export default UserExperience;
